var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { id: "jerseyModal", "hide-footer": true },
      model: {
        value: _vm.showJersey,
        callback: function($$v) {
          _vm.showJersey = $$v
        },
        expression: "showJersey"
      }
    },
    [
      _c(
        "div",
        { attrs: { id: "busForm" } },
        [
          _c(
            "div",
            { staticClass: "formTitle" },
            [
              _c("svg-image", { attrs: { image: "iconJersey" } }),
              _c("h5", [_vm._v(_vm._s(_vm.$t("register.form.detail.jersey")))])
            ],
            1
          ),
          _c(
            "b-form",
            { on: { submit: _vm.doJersey } },
            [
              _c("img", {
                attrs: {
                  src: "https://assets.heartwork.co.id/bormar/jersey.jpg",
                  alt: "Jersey"
                }
              }),
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "",
                    label: _vm.$t("register.form.detail.jersey"),
                    "label-for": "",
                    description: _vm.$t("register.form.detail.jerseyd")
                  }
                },
                [
                  _c(
                    "b-form-select",
                    {
                      model: {
                        value: _vm.jerseySize,
                        callback: function($$v) {
                          _vm.jerseySize = $$v
                        },
                        expression: "jerseySize"
                      }
                    },
                    [
                      _c("b-form-select-option", { attrs: { value: "XS" } }, [
                        _vm._v("XS")
                      ]),
                      _c("b-form-select-option", { attrs: { value: "S" } }, [
                        _vm._v("S")
                      ]),
                      _c("b-form-select-option", { attrs: { value: "M" } }, [
                        _vm._v("M")
                      ]),
                      _c("b-form-select-option", { attrs: { value: "M" } }, [
                        _vm._v("L")
                      ]),
                      _c("b-form-select-option", { attrs: { value: "XL" } }, [
                        _vm._v("XL")
                      ]),
                      _c("b-form-select-option", { attrs: { value: "2XL" } }, [
                        _vm._v("XXL")
                      ]),
                      _c("b-form-select-option", { attrs: { value: "3XL" } }, [
                        _vm._v("XXXL")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "clearfix" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        block: "",
                        type: "submit",
                        variant: "primary",
                        size: "lg"
                      }
                    },
                    [
                      _vm.loading
                        ? _c("b-spinner", {
                            attrs: { small: "", type: "grow" }
                          })
                        : _vm._e(),
                      _vm._v(" " + _vm._s(_vm.$t("register.form.jbtn")))
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/JerseyModal.vue?vue&type=template&id=1c77f19d&
// module id = 874
// module chunks = 0